import {debounce} from "../functions";

document.addEventListener("DOMContentLoaded", function (dom) {
    const faqList = document.querySelectorAll('.feed-faq');
    const searchInput = document.querySelector('.js-search-input');

    if (faqList.length && searchInput) {
        const handleInput = debounce(() => {
            faqList.forEach(faq => {
                const title = faq.querySelector('.feed-faq__inset--header--button');
                if (!title.innerText.includes(searchInput.value.trim())) {
                    faq.classList.add('hidden')
                } else {
                    faq.classList.remove('hidden')
                }
            })
        }, 300)
        searchInput.addEventListener('input', handleInput)
    }
});

